import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";

const fieldCls =
  "w-full rounded-md border border-brand-mist/20 bg-brand-charcoal px-4 py-3 text-sm text-brand-snow placeholder:text-brand-mist/50 transition-colors duration-200 focus:border-brand-emerald focus:outline-none focus:ring-1 focus:ring-brand-emerald/50";

export const Field = ({ label, htmlFor, required, hint, error, children }) => (
  <div className="space-y-2" data-testid={htmlFor ? `field-${htmlFor}` : undefined}>
    {label && (
      <Label htmlFor={htmlFor} className="text-sm font-medium text-brand-snow">
        {label}
        {required && <span className="ml-1 text-brand-emerald" aria-hidden="true">*</span>}
      </Label>
    )}
    {children}
    {hint && !error && <p className="text-xs text-brand-mist">{hint}</p>}
    {error && (
      <p className="text-xs text-red-400" role="alert">
        {error}
      </p>
    )}
  </div>
);

export const TextInput = ({ className, testid, ...props }) => (
  <input className={cn(fieldCls, className)} data-testid={testid} {...props} />
);

export const TextArea = ({ className, testid, rows = 5, ...props }) => (
  <textarea rows={rows} className={cn(fieldCls, "resize-y", className)} data-testid={testid} {...props} />
);

export const SelectInput = ({ className, testid, children, ...props }) => (
  <select className={cn(fieldCls, "appearance-none", className)} data-testid={testid} {...props}>
    {children}
  </select>
);
